import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ODataPagerComponent } from './odata-pager/odata-pager.component';
import { ODataPagerSizePickerComponent } from './odata-pager-size-picker/odata-pager-size-picker.component';

@NgModule({
    declarations: [ODataPagerComponent, ODataPagerSizePickerComponent],
    imports: [CommonModule],
    exports: [ODataPagerComponent]
})
export class ODataPagerModule {}
